import React, { createRef, useEffect } from 'react';

import { Link } from 'gatsby';
import { ScrollToPlugin } from 'gsap/all';
import gsap from 'gsap/gsap-core';

gsap.registerPlugin(ScrollToPlugin);

export const Nav = ({ mapView }) => {
    const nav = createRef();
    const headerOffset = createRef();

    useEffect(() => {
        //Set up sticky header events
        const body = document.querySelector('body');
        headerOffset.current = nav.current.getBoundingClientRect().top + document.documentElement.scrollTop;

        if (mapView) {
            body.classList.add('header-sticky');
            return;
        }

        const setStickyNav = () => {
            const compatibleScrollY = (window.scrollY && window.scrollY) || window.pageYOffset;
            if (!nav.current) return;
            const offsetTop = headerOffset.current;
            const navHeight = nav.current.clientHeight;
            var shouldBeSticky = compatibleScrollY > offsetTop ? true : false;

            // console.log('shouldbesticky', shouldBeSticky);
            // console.log('window.scrollY', compatibleScrollY);
            // console.log('headerOffset.current', headerOffset.current);

            if (shouldBeSticky) {
                body.classList.add('header-sticky');
            } else {
                body.classList.remove('header-sticky');
            }
        };

        setupHorizontalScroll('.scrolling-nav > ul');
        setStickyNav();
        window.addEventListener('scroll', setStickyNav);

        return () => {
            window.removeEventListener('scroll', setStickyNav);
            body.classList.remove('header-sticky');
        };
    }, []);

    const setupHorizontalScroll = (selector) => {
        setTimeout(function () {
            const tabs = document.querySelector(selector);
            
            //TODO:
            setTimeout(() => {
                const tabButtons = tabs.querySelectorAll('a');
                for (let i = 0; i < tabButtons.length; i++) {
                    const el = tabButtons[i];
                    if (el.classList.contains('active')) {
                        const li = el.parentNode;
                        // const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
                        tabs.scrollLeft = li.offsetLeft;
                    }
                }
            }, 200);

            tabs.addEventListener('scroll', () => {
                const leftPos = tabs.scrollLeft;

                if (tabs.scrollWidth - tabs.clientWidth - leftPos < 50) {
                    tabs.parentNode.classList.add('end-scroll');
                } else {
                    tabs.parentNode.classList.remove('end-scroll');
                }
            });
        }, 100);
    };

    return (
        <div className="site-nav" ref={nav}>
            <nav className="scrolling-nav">
                <ul>
                    <li>
                        <Link activeClassName="active" to="/">
                            HOME
                        </Link>
                    </li>
                    <li>
                        <Link activeClassName="active" to="/year-in-review/">
                            OUR YEAR IN NUMBERS
                        </Link>
                    </li>
                    <li>
                        <Link activeClassName="active" to="/kpis/">
                            KPIs
                        </Link>
                    </li>
                    <li>
                        <Link activeClassName="active" to="/incidents/">
                            INCIDENTS
                        </Link>
                    </li>
                    <li>
                        <Link activeClassName="active" to="/the-esl">
                            THE ESL
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};
